import { ApolloError } from '@apollo/client';
import { ReviewRatings } from '../components';
import { useDesignerLatestReviewQuery } from '../graphql/DesignerLatestReview.generated';

type Options = {
    requestId: string;
    skip?: boolean;
    onError?: (error: Error) => void;
};

type Result = {
    latestReview: ReviewRatings | undefined;
    loading: boolean;
};

export function useLatestDesignerReview({ requestId, skip = false, onError }: Options): Result {
    const { data, loading } = useDesignerLatestReviewQuery({
        variables: { requestId },
        skip,
        fetchPolicy: 'cache-and-network',
        onError: (error: ApolloError) => onError?.(error),
    });

    const review = data?.request.collaborationListItem?.latestReview;

    return {
        latestReview: review
            ? {
                  overall: review.rating,
                  comment: review.comment ?? '',
                  criteria: review.criteria ?? [],
              }
            : undefined,
        loading: !skip && loading && !data,
    };
}
